module.exports = __webpack_public_path__ + "img/c14.f348621e.png";